import { Box } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { mainMenuVisible, menuVisible } from '../../redux/Actions'

const ReportHeader = ({ mainHeaderName = "", headerName, subHeader = "", fixedTopPosition = false, openSubMenu = () => { }, mainMenuOpen = true, subMenuOpen = true, subHeaderVisible = false, control = '', defaultTopPosition = '40px' }) => {
    const dispatch = useDispatch()
    const [topPosition, setTopPosition] = useState(0)

    useEffect(() => {
        if (defaultTopPosition || fixedTopPosition) {
            setTopPosition(defaultTopPosition)
        } else {
            const reportHeaderElement = document.querySelector('.report_header');
            const rect = reportHeaderElement.getBoundingClientRect();
            setTopPosition(rect.top)
        }
    }, [defaultTopPosition, fixedTopPosition])
    const mainMenu = () => {
        if (mainMenuOpen) {
            dispatch(menuVisible())
            dispatch(mainMenuVisible(true))
        }
    }
    const subMenuVisible = () => {
        if (subMenuOpen) {
            dispatch(menuVisible())
            dispatch(mainMenuVisible(false))
            openSubMenu()
        }
    }
    const subHeaderMenuVisible = () => {
        if (subHeaderVisible) {
            dispatch(menuVisible())
            dispatch(mainMenuVisible(false))
            subHeaderVisible()
        }
    }
    return (
        <Box className='report_header' id='reportheader' sx={fixedTopPosition ? { position: 'sticky', top: topPosition, zIndex: 3 } : {}}>
            <span style={{ textTransform: "uppercase" }} className="report-span">
                <span onClick={mainMenu} style={{ cursor: "pointer" }}>{mainHeaderName}</span> {headerName !== "" && <>{`>`} <span style={{ cursor: "pointer" }} onClick={subMenuVisible}> {headerName}</span></>} {subHeader !== "" && <>{`>`} <span style={{ cursor: "pointer" }} onClick={subHeaderMenuVisible}> {subHeader}</span></>}
                <span className='headcontrol'>{control}</span>
            </span>
        </Box>
    )
}

export default ReportHeader
